var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe"},[_c('iframe',{attrs:{"id":"lanqiao","src":_vm.srcData,"frameborder":"0","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }